// extracted by mini-css-extract-plugin
module.exports = {"noOverallScoreMessage":"style-module__noOverallScoreMessage___2dMMk","textDivider":"style-module__textDivider___2WyJU"};